// LA TIENDA DEL PANEL DE ADMINISTRACIÓN: LAS TARJETAS DE LOS APARATOS Y EL ENLACE «VER EN LA TIENDA»   (t217, B-1642)
//
// El dueño, el 14-oct-2026: «Lo del enlace del escáner lo pondría en una especie de "Tienda" en panel admin... así si el
// día de mañana lo vendemos nosotros pues es más fácil». La página es pages/Tienda (/administracion/tienda y la ficha de
// cada aparato, /administracion/tienda/<aparato>); los productos y sus enlaces son DATOS de Biango (Superadmin → Sistemas;
// el servidor: GET /api/enlaces-compra/tienda, services/enlacesCompra).
//
// POR QUÉ EN `utils/`, SIN ESTADO Y SIN MÁS IMPORT QUE REACT: el enlace «Ver en la Tienda» lo llevan pantallas que muchas
// guardias montan con sus dobles (Sistema de fichaje, Dispositivos de firma, Almacén → Escanear); los `utils/` se cargan DE
// VERDAD en ellas (test-helpers/utilDelFrontend), y un componente con estado propio dentro no se puede expandir. Un <a> no
// pide nada al abrir la pantalla. La tarjeta tampoco tiene estado: la pinta la página con lo que contesta el servidor.
// (t315 · el único import es otro `utils/` sin estado, utils/rutaInterna: en la app del móvil la Tienda se abre DENTRO.)
import { enlaceInterno } from './rutaInterna'
import { t as i18nT, tx, marca } from './i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const RUTA_TIENDA = '/administracion/tienda'
const CLAVE = /^[a-z0-9_]{2,40}$/
const HTTPS = /^https:\/\/\S+$/

/** La ficha de un aparato dentro de la Tienda; con una clave que no lo es, la Tienda entera. */
export function rutaProducto(clave) {
  return CLAVE.test(String(clave || '')) ? RUTA_TIENDA + '/' + clave : RUTA_TIENDA
}

/** «Ver en la Tienda»: donde la app pide un aparato. Abre su ficha en otra pestaña (la pantalla de la que viene se queda);
 *  en la app del móvil, que no tiene pestañas, dentro (t315). */
export function EnlaceTienda({ producto, texto = i18nT('utils.tienda.ver_en_la_tienda', 'Ver en la Tienda') }) {
  if (!CLAVE.test(String(producto || ''))) return null
  return (
    <div data-ver-en-la-tienda={producto} style={{ marginTop: '10px' }}>
      <a {...enlaceInterno(rutaProducto(producto))} data-abrir-tienda={producto}
        style={{ color: 'var(--primary)', fontSize: '12.5px', fontWeight: 700, textDecoration: 'underline' }}>{texto}</a>
    </div>
  )
}

// ── LOS DIBUJOS DE LAS TARJETAS (el `icono` de cada producto; uno que no esté aquí sale como «caja») ──────────────
const DIBUJOS = {
  tablet: <><rect x="5" y="2" width="14" height="20" rx="2" /><line x1="10" y1="18" x2="14" y2="18" /></>,
  lector: <><path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" /><path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" /><line x1="7" y1="8" x2="7" y2="16" /><line x1="10" y1="8" x2="10" y2="16" /><line x1="13" y1="8" x2="13" y2="16" /><line x1="17" y1="8" x2="17" y2="16" /></>,
  escaner: <><path d="M6 9V3h12v6" /><rect x="3" y="9" width="18" height="8" rx="2" /><line x1="7" y1="13" x2="17" y2="13" /><path d="M6 17v4h12v-4" /></>,
  lapiz: <path d="M17 3a2.8 2.8 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />,
  soporte: <><rect x="7" y="2" width="10" height="14" rx="1.5" /><line x1="12" y1="16" x2="12" y2="20" /><line x1="8" y1="22" x2="16" y2="22" /></>,
  caja: <><path d="M21 8 12 3 3 8v8l9 5 9-5z" /><path d="M3 8l9 5 9-5" /><line x1="12" y1="13" x2="12" y2="21" /></>,
}
/** Los dibujos que se pueden elegir en Superadmin, con su nombre. */
export const DIBUJOS_TIENDA = [['tablet', marca('utils.tienda.tablet', 'Tablet')], ['lector', marca('utils.tienda.lector_de_codigos', 'Lector de códigos')], ['escaner', marca('utils.tienda.escaner', 'Escáner')], ['lapiz', marca('utils.tienda.lapiz', 'Lápiz')], ['soporte', marca('utils.tienda.soporte', 'Soporte')], ['caja', marca('utils.tienda.otro_caja', 'Otro (caja)')]]

export function DibujoProducto({ icono, s = 30 }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" data-dibujo={DIBUJOS[icono] ? icono : 'caja'} style={{ display: 'block' }}>{DIBUJOS[icono] || DIBUJOS.caja}</svg>
  )
}

/** 12990 → «129,90 €». Sin precio, nada. */
export function precioTexto(centimos, moneda = 'EUR') {
  if (centimos === null || centimos === undefined || centimos === '' || !Number.isFinite(Number(centimos))) return ''
  const t = (Number(centimos) / 100).toFixed(2).replace('.', ',')
  return moneda === 'EUR' ? t + ' €' : t + ' ' + moneda
}

/** Los productos que sirven de lo que contesta el servidor. */
export function productosQueSirven(datos) {
  return (datos && datos.disponible === true && Array.isArray(datos.productos))
    ? datos.productos.filter((p) => p && CLAVE.test(String(p.clave || '')) && p.nombre)
    : []
}

/** Dónde lleva «Comprar»: lo que vende Biango, a su tienda; lo demás, a sus enlaces de afiliado (patrocinados). Solo https. */
export function comprasDe(p) {
  if (!p) return []
  if (p.vendedor === 'biango') {
    return HTTPS.test(String(p.url_biango || '')) ? [{ clave: 'biango', texto: i18nT('utils.tienda.en_la_tienda_de_biango', 'En la tienda de Biango'), tienda: '', url: p.url_biango, rel: 'noopener noreferrer' }] : []
  }
  return (Array.isArray(p.enlaces) ? p.enlaces : [])
    .filter((e) => e && e.id != null && HTTPS.test(String(e.url || '')) && e.texto)
    .map((e) => ({ clave: 'e' + e.id, texto: e.texto, tienda: e.tienda || '', url: e.url, rel: 'noopener noreferrer sponsored' }))
}

const caja = { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '14px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px', minWidth: 0 }
const rotulo = { fontSize: '11.5px', fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: '4px' }

/** La tarjeta de un aparato (en la ficha, `ficha`: más grande y sin «Ver ficha»). `verFicha(clave)` pinta ese enlace. */
export function TarjetaProducto({ producto: p, verFicha, ficha = false }) {
  const compras = comprasDe(p)
  const requisitos = Array.isArray(p.requisitos) ? p.requisitos.filter((r) => typeof r === 'string' && r.trim()) : []
  const precio = p.vendedor === 'biango' ? precioTexto(p.precio_centimos, p.moneda) : ''
  const imagen = HTTPS.test(String(p.imagen_url || '')) ? p.imagen_url : null
  const lado = ficha ? 76 : 56
  return (
    <div data-producto-tienda={p.clave} style={{ ...caja, ...(ficha ? { padding: '20px', maxWidth: '720px' } : null) }}>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <div style={{ width: lado + 'px', height: lado + 'px', flex: '0 0 auto', borderRadius: '12px', overflow: 'hidden', display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: 'var(--primary)', background: 'color-mix(in srgb, var(--primary) 9%, transparent)' }}>
          {imagen
            ? <img src={imagen} alt={p.nombre} data-imagen-producto="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : <DibujoProducto icono={p.icono} s={ficha ? 40 : 30} />}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: ficha ? '20px' : '15.5px', fontWeight: 800, lineHeight: 1.25, color: 'var(--text-primary)' }}>{p.nombre}</div>
          {p.vendedor === 'biango' && (
            <div data-lo-vende-biango="" style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--success)', marginTop: '2px' }}>
              {tx('utils.tienda.lo_vende_biango', 'Lo vende Biango{{x}}', { x: precio ? ' · ' + precio : '' })}
            </div>
          )}
        </div>
      </div>
      {p.para_que ? <div style={{ fontSize: '13.5px', color: 'var(--text-secondary)', lineHeight: 1.55 }}>{p.para_que}</div> : null}
      {requisitos.length > 0 && (
        <div>
          <div style={rotulo}>{i18nT('utils.tienda.que_tiene_que_tener', 'Qué tiene que tener')}</div>
          <ul data-requisitos={p.clave} style={{ margin: 0, padding: '0 0 0 18px', fontSize: '13px', lineHeight: 1.6, color: 'var(--text-primary)' }}>
            {requisitos.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
        </div>
      )}
      {p.donde_se_usa ? <div style={{ fontSize: '12.5px', color: 'var(--text-muted)' }}>{i18nT('utils.tienda.donde_se_usa_en_biango', 'Dónde se usa en Biango: ')}<b style={{ color: 'var(--text-secondary)' }}>{p.donde_se_usa}</b></div> : null}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: 'auto' }}>
        {compras.length ? compras.map((c) => (
          <div key={c.clave} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <a href={c.url} target="_blank" rel={c.rel} data-comprar={c.clave}
              style={{ display: 'inline-flex', alignItems: 'center', padding: '7px 14px', borderRadius: '9px', background: 'var(--primary)', color: 'var(--sobre-primary)',
                fontSize: '13px', fontWeight: 800, textDecoration: 'none', flex: '0 0 auto' }}>{i18nT('utils.tienda.comprar', 'Comprar')}</a>
            <span style={{ fontSize: '12.5px', color: 'var(--text-secondary)', minWidth: 0, flex: '1 1 160px' }}>{c.texto}{c.tienda ? i18nT('utils.tienda.en', ' · en {{tienda}}', { tienda: c.tienda }) : ''}</span>
          </div>
        )) : <div data-sin-compra={p.clave} style={{ fontSize: '12.5px', color: 'var(--text-muted)' }}>{i18nT('utils.tienda.ahora_mismo_no_hay_donde', 'Ahora mismo no hay dónde comprarlo.')}</div>}
        {!ficha && verFicha ? verFicha(p.clave) : null}
      </div>
    </div>
  )
}

/** El pie de la Tienda: que son búsquedas y, abajo y discreta, la frase legal de cada tienda (la que su programa de
 *  afiliados obliga a poner donde salen sus enlaces: «Como Afiliado de Amazon, Biango obtiene ingresos…», editable en
 *  Superadmin) SOLO si alguno de los «Comprar» que se ven lleva su identificador. Sin ninguno, no sale. */
export function PieTienda({ frases }) {
  const lista = Array.isArray(frases) ? frases.filter((f) => typeof f === 'string' && f.trim()) : []
  return (
    <div data-pie-tienda="" style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '16px', lineHeight: 1.55, maxWidth: '900px' }}>
      <div>{i18nT('utils.tienda.los_enlaces_son_busquedas_con', 'Los enlaces son búsquedas con lo que hace falta, no un modelo concreto: elige el que te encaje.')}</div>
      {lista.map((f, i) => <div key={i} data-frase-afiliado="" style={{ fontSize: '11.5px', marginTop: '6px' }}>{f}</div>)}
    </div>
  )
}
